import { Box, Button, Collapse, Divider, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'


const ResultSection = ({ results, deleteResults }) => {

  return (
    <>
      <Box display='flex' sx={{ flexDirection: 'column-reverse' }}>
        {results.map((result, index) => (
          <ResultCard
            key={index}
            result={result}
            index={index}
            length={results.length} />
        ))}
        {results.length > 0 &&
          <Button variant='outlined' sx={{ alignSelf: 'flex-end' }} onClick={deleteResults}>
            Clear Results
          </Button>
        }
      </Box>
    </>
  )
}


const ResultCard = ({ result, index, length }) => {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    setTimeout(() => setVisible(true), (length - 1 - index) * 350)
  }, [])
  return (
    <Collapse in={visible} timeout={500}>
      <Paper component='article' sx={{ my: 1 }}>
        <Box display='flex' sx={{ p: 2 }}>
          <Typography sx={{ minWidth: '6rem' }}>Prompt</Typography>
          <Typography>{result.prompt}</Typography>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Box display='flex' sx={{ p: 2 }}>
          <Typography sx={{ minWidth: '6rem' }}>Response</Typography>
          <Typography component='p' sx={{ whiteSpace: 'pre-line' }}>
            {result.text.replace('\n\n', '')}</Typography>
        </Box>
      </Paper>
    </Collapse>)
}

export default ResultSection